module.exports = __webpack_public_path__ + "static/media/SharpSansDispNo1-Medium.d6aeff93.ttf";